export default "__VITE_ASSET__BDBSNIGm__"